"use strict";
angular.module('newListModule', []).controller('newListCtrl', ['$scope','$stateParams',"trsHttpService","$rootScope", "$timeout", "$state", "dateFilter", "trsspliceString", "modalDialog"
    ,function($scope,$stateParams,trsHttpService,$rootScope, $timeout, $state, dateFilter, trsspliceString, modalDialog) {
        initStatus();
        initData();
        /**
         * [initStatus description] 状态
         * @return {[type]} [description]
         */
       function initStatus(){
           $scope.data={
               viewpoinManuData:[],
               keyword:''
           };
           $scope.status={
               id:$stateParams.id,
               copyCurrPage: 1,
               keyword:$stateParams.keyword
           };
           $scope.page={
               CURRPAGE:1,
               ITEMCOUNT: 0,
               PAGECOUNT: 1,
               PAGESIZE:20,
           };
           $scope.params={
               typeid: 'event',
               serviceid: 'eventdetail',
               modelid:'entitydetail',
               eventid: $scope.status.id,
               slaveid:'',
               page_no:$scope.page.CURRPAGE-1,
               page_size:$scope.page.PAGESIZE,
               keyword: $scope.status.keyword,
               search_word:'',
               field:$stateParams.field,
           };
       }
        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
       function initData(){
           requestData();
       }
        /**
         * [requestData description] 基本信息数据
         * @return {[type]} [description]
         */
       function requestData(){
           $scope.loadingPromise= trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "GET").then(function(data) {
               if(angular.isDefined(data)){
                   $scope.data.viewpoinManuData=data.PAGEITEMS;
                   $scope.page.ITEMCOUNT=data.PAGETOTAL;
               }
           });
        }
        /**
         * [fullTextSearch description;全文检索]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.page.CURRPAGE = 1;
                $scope.params.search_word=$scope.data.keyword;
                requestData();
            }
        };
        /**
         * [selectPageNum description]选择单页个数
         * @return {[type]} [description] null
         */
        $scope.selectPageNum = function() {
            $scope.params.page_size = $scope.page.PAGESIZE;
            $scope.params.page_no = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = 1;
            requestData();
        };
        /**
         * [pageChanged description]下一页
         * @return {[type]} [description] null
         */
        $scope.pageChanged = function() {
            $scope.params.page_no = $scope.page.CURRPAGE;
            requestData();
        };
        //跳转到开始
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.params.page_no = $scope.status.copyCurrPage;
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };
    }]);